import React from 'react';
import { Link } from 'react-router-dom';

// project-import
import SectionTitle from '../sectionTitle/SectionTitle';
import CalendlyPopupButton from '../calendly/CalendlyPopupButton';
import SalesforceNewsLettterStencil from '../newsletter/SalesforceNewsLettterStencil';
import ConsultationCallToActionStencil from './ConsultationCallToActionStencil';


// Reading Environment Variables
const OFFICIAL_EMAIL_ADDRESS = process.env.REACT_APP_OFFICIAL_EMAIL_ADDRESS;

const ConsultationCallToAction = ({ stencilLoading }) => {

    if (stencilLoading) {
        return <ConsultationCallToActionStencil />
    }


    return (
        <div className="edu-newsletter-area bg-image newsletter-style-3 edu-section-gap bg-color-primary">
            <div className="container eduvibe-animated-shape">
                <div className="row y-gap-15 align-items-center">
                    <div className="col-12 col-xl-6">
                        <div className="inner">
                            <SectionTitle
                                classes="text-white text-start"
                                slogan="Schedule Your 1:1 Consultation"
                                title="Get personalised guidance"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-xl-6">
                        <div className="newsletter-right-content d-block d-md-flex align-items-center justify-content-start justify-content-xl-end">
                            <div className="contact-btn">
                                {/* <Link className="edu-btn btn-white" to="#">Get Started Now<i className="icon-arrow-right-line-right"></i></Link> */}
                                <CalendlyPopupButton btnText="Book 1:1 Consultation" color='#F86F03' className='edu-btn subscribe btn-medium' />
                            </div>
                            <div className="contact-info">
                                <a href={`mailto: ${OFFICIAL_EMAIL_ADDRESS}`} className="fs-4"><i className="icon-mail-line-2"></i> {OFFICIAL_EMAIL_ADDRESS}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConsultationCallToAction;